import { render, staticRenderFns } from "./BotaoMonitorar.vue?vue&type=template&id=3722948c&"
import script from "./BotaoMonitorar.vue?vue&type=script&lang=js&"
export * from "./BotaoMonitorar.vue?vue&type=script&lang=js&"
import style0 from "./BotaoMonitorar.vue?vue&type=style&index=0&id=3722948c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports